import Dropdown from "@stimulus-components/dropdown"
import { useClickOutside } from "stimulus-use"

export default class extends Dropdown {
  connect() {
    super.connect()
    useClickOutside(this)
  }

  toggle(event) {
    super.toggle()
  }

  hide(event) {
    super.hide(event)
  }

  clickOutside(event) {
    this.hide(event)
  }
}